import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ProtectedRoute from '../components/common/protectedRoute';
import RoleProtectedRoute from '../components/common/RoleProtectedRoute';
import ErrorBoundary from '../components/ErrorBoundary';
import HCPLayout from '../layout/hcp_layout';
import AuthLayout from '../layout/auth_layout';
import Role from '../pages/role';
import Organization from '../pages/organization';
import CompleteProfile from '../pages/complete_profile';
import PatientLayout from '../layout/patient_layout';
import AdminLayout from '../layout/AdminLayout';
import Unauthorized from '../pages/Unauthorized';
import FirstLoginProfileLayout from '../layout/FirstLoginProfileLayout';

const Routes = () => {
    return (
        <ErrorBoundary>
            <Switch>
                <ProtectedRoute path='/user/organization' component={Organization} />
                <ProtectedRoute path='/user/role' component={Role} />
                <ProtectedRoute path='/user/completeprofile' component={CompleteProfile} />
                <Route path='/user' component={AuthLayout} />
                <Route path='/unauthorized' component={Unauthorized} />
                <ProtectedRoute
                    path='/hcp/first_login_profile'
                    component={FirstLoginProfileLayout}
                />
                <RoleProtectedRoute
                    path='/hcp'
                    component={HCPLayout}
                    allowedRoles={['HEALTH_CARE_PROVIDER', 'CLINICAL_LOCATION_ADMIN']}
                />
                <RoleProtectedRoute
                    path='/patient'
                    component={PatientLayout}
                    allowedRoles={['PATIENT']}
                />
                <RoleProtectedRoute
                    path='/admin'
                    component={AdminLayout}
                    allowedRoles={['ORG_ADMIN']}
                />
                <Redirect from='/' to='/user' />
            </Switch>
        </ErrorBoundary>
    )
}

export default Routes;